module.exports = __webpack_public_path__ + "img/team10.b5ddab7f.jpg";